import { Formik, Form } from 'formik';
import withStyles from '@material-ui/styles/withStyles';
import { Grid, Typography, Chip } from '@material-ui/core';

import SelectTextFieldFormik from 'app/components/form/formik/SelectTextFieldFormik';
import { SCHEMATIC_VERSION_FORM_VALUES } from 'features/wells/schematics/helpers/constants';
import { fromJS } from 'immutable';
import moment from 'moment';
import { Format } from 'app/app.constants';

const SchematicVersionForm = ({
  versionsList,
  onChange,
  selectedSchematicVersion,
  classes,
}) => {
  const getItemName = (element) =>
    moment(element).format(`${Format.date_dayfirst}, hh:mm A`);
  const selectedValue =
    selectedSchematicVersion ??
    (versionsList.length > 0 ? versionsList[0] : '');

  if (versionsList.length === 0) {
    return null;
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{
        [SCHEMATIC_VERSION_FORM_VALUES.VERSION]: selectedValue,
      }}
    >
      {() => (
        <Form className={classes.form}>
          <Typography type="body-2">Version:</Typography>
          <SelectTextFieldFormik
            className={classes.field}
            margin="none"
            items={fromJS(versionsList)}
            name={SCHEMATIC_VERSION_FORM_VALUES.VERSION}
            getItemValue={(element) => element}
            getItemName={(element) => (
              <Grid className={classes.container}>
                <Typography className={classes.date}>
                  {getItemName(element)}
                </Typography>
                {versionsList[0] === element && (
                  <Chip className={classes.chip} label="Latest version" />
                )}
              </Grid>
            )}
            displayEmpty={false}
            SelectProps={{
              onChange,
            }}
          />
        </Form>
      )}
    </Formik>
  );
};

const styles = (theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  field: {
    paddingLeft: theme.spacing(1),
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  date: {
    fontWeight: 300,
  },
  chip: {
    marginLeft: theme.spacing(2),
    fontWeight: 300,
  },
});

export default withStyles(styles)(SchematicVersionForm);
